import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollReveal = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;

    const els = Array.from(document.querySelectorAll<HTMLElement>('[data-reveal]:not(.is-in)'));
    if (els.length === 0) return undefined;

    for (const el of els) {
      const siblings = el.parentElement
        ? Array.from(el.parentElement.querySelectorAll(':scope > [data-reveal]'))
        : [];
      const i = Math.max(0, siblings.indexOf(el));
      el.style.transitionDelay = `${Math.min(i, 6) * 55}ms`;
    }

    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const el = entry.target as HTMLElement;
          el.classList.add('is-in');
          io.unobserve(el);
          const release = (e: TransitionEvent) => {
            if (e.target !== el || (e.propertyName !== 'opacity' && e.propertyName !== 'transform')) return;
            el.style.willChange = 'auto';
            el.removeEventListener('transitionend', release);
          };
          el.addEventListener('transitionend', release);
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 },
    );

    for (const el of els) io.observe(el);
    return () => io.disconnect();
  }, [pathname]);

  return null;
};
